import { createReducer, on } from '@ngrx/store';
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import { BillingTransfersState } from './billing.transfers.models';
import { Pagination } from '../../../shared/models/list.page.model';
import * as transfersActions from './billing.transfers.actions';

export const billingTransfersInitialState: BillingTransfersState = {
  loading: false,
  error: null,
  transfers: [],
  transfersPage: null,
  pagination: {
    pageIndex: 0,
    pageSize: paginationConstants.DefaultPageSize,
  },
  filterParameters: null,
  currentFilter: null,
  dateFrom: null,
  dateTo: null,
  operatorId: null,
};

export const billingTransfersReducer = createReducer(
  billingTransfersInitialState,
  on(transfersActions.initTransfers, (state, { operatorId, dateFrom, dateTo }) => ({
    ...state,
    operatorId,
    dateFrom: dateFrom ?? null,
    dateTo: dateTo ?? null,
    pagination: {
      pageIndex: 0,
      pageSize: state.pagination ? state.pagination.pageSize : paginationConstants.DefaultPageSize,
    } as Pagination,
  })),
  on(transfersActions.loadTransfers, (state) => ({
    ...state,
    loading: true,
  })),
  on(transfersActions.loadTransfersSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    transfers: response.result ?? [],
    transfersPage: {
      pageIndex: response.pageIndex ?? 0,
      pageSize: response.pageSize ?? 0,
      totalCount: response.total ?? 0,
    },
  })),
  on(transfersActions.loadTransfersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(transfersActions.loadTransferFilterParameters, (state) => ({
    ...state,
    filterParameters: null,
  })),
  on(transfersActions.loadTransferFilterParametersSuccess, (state, { filterParameters }) => ({
    ...state,
    filterParameters,
  })),
  on(transfersActions.changeTransferFilter, (state, { filter }) => ({
    ...state,
    currentFilter: { ...filter },
    pagination: { pageIndex: 0, pageSize: state.pagination ? state.pagination.pageSize : paginationConstants.DefaultPageSize } as Pagination,
  })),
  on(transfersActions.changeTransferPagination, (state, { pageIndex, pageSize }) => ({
    ...state,
    pagination: { pageIndex, pageSize },
  })),
  on(transfersActions.changeTransferDateRange, (state, { dateFrom, dateTo }) => ({
    ...state,
    dateFrom: dateFrom ?? null,
    dateTo: dateTo ?? null,
    pagination: { pageIndex: 0, pageSize: state.pagination ? state.pagination.pageSize : paginationConstants.DefaultPageSize } as Pagination,
  })),
  on(transfersActions.recallTransfer, (state) => ({
    ...state,
    loading: true,
  })),
  on(transfersActions.recallTransferSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(transfersActions.recallTransferFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
);
